/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  unref
} from 'vue';

import type {
  StandardError,
  UserRsiVerification,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Show the RSI handle verification
 */
export const myRsiVerification = (

 signal?: AbortSignal
) => {


      return axiosClient<UserRsiVerification>(
      {url: `/me/rsi-verification`, method: 'GET', signal
    },
      );
    }




export const getMyRsiVerificationQueryKey = () => {
    return [
    'me','rsi-verification'
    ] as const;
    }


export const getMyRsiVerificationQueryOptions = <TData = Awaited<ReturnType<typeof myRsiVerification>>, TError = ErrorType<StandardError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof myRsiVerification>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getMyRsiVerificationQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof myRsiVerification>>> = ({ signal }) => myRsiVerification(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof myRsiVerification>>, TError, TData>
}

export type MyRsiVerificationQueryResult = NonNullable<Awaited<ReturnType<typeof myRsiVerification>>>
export type MyRsiVerificationQueryError = ErrorType<StandardError>


/**
 * @summary Show the RSI handle verification
 */

export function useMyRsiVerification<TData = Awaited<ReturnType<typeof myRsiVerification>>, TError = ErrorType<StandardError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof myRsiVerification>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMyRsiVerificationQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Issue a new RSI handle verification token
 */
export const createMyRsiVerification = (

 signal?: AbortSignal
) => {


      return axiosClient<UserRsiVerification>(
      {url: `/me/rsi-verification`, method: 'POST', signal
    },
      );
    }




export const getCreateMyRsiVerificationMutationKey = () => ['createMyRsiVerification'] as const;

export const getCreateMyRsiVerificationMutationOptions = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMyRsiVerification>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createMyRsiVerification>>, TError,void, TContext> => {

const mutationKey = getCreateMyRsiVerificationMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createMyRsiVerification>>, void> = () => {


          return  createMyRsiVerification()
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateMyRsiVerificationMutationResult = NonNullable<Awaited<ReturnType<typeof createMyRsiVerification>>>

    export type CreateMyRsiVerificationMutationError = ErrorType<StandardError>


    /**
 * @summary Issue a new RSI handle verification token
 */
export const useCreateMyRsiVerification = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMyRsiVerification>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createMyRsiVerification>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getCreateMyRsiVerificationMutationOptions(options), queryClient);
    }
    /**
 * @summary Remove the RSI handle verification
 */
export const destroyMyRsiVerification = (

 signal?: AbortSignal
) => {


      return axiosClient<UserRsiVerification>(
      {url: `/me/rsi-verification`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyMyRsiVerificationMutationKey = () => ['destroyMyRsiVerification'] as const;

export const getDestroyMyRsiVerificationMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyMyRsiVerification>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyMyRsiVerification>>, TError,void, TContext> => {

const mutationKey = getDestroyMyRsiVerificationMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyMyRsiVerification>>, void> = () => {


          return  destroyMyRsiVerification()
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyMyRsiVerificationMutationResult = NonNullable<Awaited<ReturnType<typeof destroyMyRsiVerification>>>

    export type DestroyMyRsiVerificationMutationError = ErrorType<ValidationError | StandardError>


    /**
 * @summary Remove the RSI handle verification
 */
export const useDestroyMyRsiVerification = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyMyRsiVerification>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyMyRsiVerification>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getDestroyMyRsiVerificationMutationOptions(options), queryClient);
    }
    /**
 * @summary Check the RSI citizen page for the verification token
 */
export const checkMyRsiVerification = (

 signal?: AbortSignal
) => {


      return axiosClient<UserRsiVerification>(
      {url: `/me/rsi-verification/check`, method: 'POST', signal
    },
      );
    }




export const getCheckMyRsiVerificationMutationKey = () => ['checkMyRsiVerification'] as const;

export const getCheckMyRsiVerificationMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkMyRsiVerification>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof checkMyRsiVerification>>, TError,void, TContext> => {

const mutationKey = getCheckMyRsiVerificationMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof checkMyRsiVerification>>, void> = () => {


          return  checkMyRsiVerification()
        }






  return  { mutationFn, ...mutationOptions }}

    export type CheckMyRsiVerificationMutationResult = NonNullable<Awaited<ReturnType<typeof checkMyRsiVerification>>>

    export type CheckMyRsiVerificationMutationError = ErrorType<ValidationError | StandardError>


    /**
 * @summary Check the RSI citizen page for the verification token
 */
export const useCheckMyRsiVerification = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkMyRsiVerification>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof checkMyRsiVerification>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getCheckMyRsiVerificationMutationOptions(options), queryClient);
    }
